import * as React from "react";
import { ODataParams, Query } from "../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { OscillometryAnalysisListTable } from "./OscillometryAnalysisListTable";

declare const window: any;

export const OscillometryAnalysisListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();


    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getOscillometryAnalysisSets(undefined, filter, params.orderby, 'session($expand=visit($expand=subject($expand=site)))', params.top, params.skip, undefined, true);
    }
    
    return (
        <DocumentTitle title="Oscillometry Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh}>
                <OscillometryAnalysisListTable />
            </Query>
        </DocumentTitle>
    );
}
